import { create } from "zustand";
import CreditService from "../services/CreditService";

const TransactionHistoryStore = create((set, get) => ({
  data: {},
  fetchedState: "LOADING",
  fetchHistory: async ({ dateId, tabId, page, recruiterId }) => {
    try {
      const response = await CreditService.getTransactionHistory({
        dateId,
        tabId,
        page,
        recruiterId
      });
      set({
        data: { ...response },
        fetchedState: "SUCCESS"
      });
    } catch (err) {
      set({
        fetchedState: "ERROR",
        data: {}
      });
    }
  }
}));

export default TransactionHistoryStore;
